<template>
    <div class="app" id="wrapper">
        <!--<form id="pay_form" action="https://gateway.test.95516.com/gateway/api/frontTransReq.do" method="post">-->
            <!--<input type="hidden" name="bizType" id="bizType" value="000201"/>-->
            <!--<input type="hidden" name="txnSubType" id="txnSubType" value="01"/>-->
            <!--<input type="hidden" name="orderId" id="orderId" value="221900000001922"/>-->
            <!--<input type="hidden" name="backUrl" id="backUrl"-->
                   <!--value="http://localhost:8080/ACPSample_AppServer/frontRcvResponse"/>-->
            <!--<input type="hidden" name="signature" id="signature"-->
                   <!--value="Am4rvgQ6EyH3hae4sFIWW52LJf/i3yYHYrhG++vgf052wmu4SCeK8GjeZb8LhAvAgHln9RmsQubeW0r3OihWliGhhXIb/WqXmsMDZ7Ow+gDs3+Yd9JSO7d/YrTn9FZJdDS397IWTBNH27i4BYVQh4ev/ZIcgxK0EqlXjEExgA4S0m471I9hqeeMB/WDyeyPv7jVi2vpkSpYJkY3b5ei2+csJ9K/sGhhs1z5oeKDs69P9/O+hWWZGFGduNExaEca98DY2EljNycyx7KLLOzfccTYLr7AWPfw/XPPosUGa09iwz/7Lv7IBWuzfpCFkPJYU2I1nqLH3+24lQrUgEGOfwA=="/>-->
            <!--<input type="hidden" name="txnType" id="txnType" value="01"/>-->
            <!--<input type="hidden" name="channelType" id="channelType" value="08"/>-->
            <!--<input type="hidden" name="frontUrl" id="frontUrl"-->
                   <!--value="http://localhost:8080/ACPSample_AppServer/frontRcvResponse"/>-->
            <!--<input type="hidden" name="certId" id="certId" value="68759663125"/>-->
            <!--<input type="hidden" name="encoding" id="encoding" value="UTF-8"/>-->
            <!--<input type="hidden" name="version" id="version" value="5.1.0"/>-->
            <!--<input type="hidden" name="accessType" id="accessType" value="0"/>-->
            <!--<input type="hidden" name="reserved" id="reserved" value="{cardNumberLock=1}"/>-->
            <!--<input type="hidden" name="txnTime" id="txnTime" value="20180626134718"/>-->
            <!--<input type="hidden" name="merId" id="merId" value="777290058154462"/>-->
            <!--<input type="hidden" name="accType" id="accType" value="01"/>-->
            <!--<input type="hidden" name="currencyCode" id="currencyCode" value="156"/>-->
            <!--<input type="hidden" name="signMethod" id="signMethod" value="01"/>-->
            <!--<input type="hidden" name="orderDesc" id="orderDesc" value="????"/>-->
            <!--<input type="hidden" name="txnAmt" id="txnAmt" value="1930200"/>-->
        <!--</form>-->
    </div>
    <!--<script type="text/javascript">document.all.pay_form.submit();</script>-->

</template>

<script>
    export default {
        data(){
            return {
                htmlInfo: '',
            }
        },

        name: "HtmlPage",

        mounted() {
            this.htmlInfo = this.$store.state.paramModule.param.paySuccess.unionPayInfo;
            document.getElementById('wrapper').innerHTML = this.htmlInfo
            this.refresh()
        },

        methods: {
            refresh() {
                document.all.pay_form.submit();
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// UnionPay.vue?42d400fe